import {
  Card,
  CardContent,
  Typography,
  Box,
  Chip,
  Stack,
  useTheme,
  Divider,
  Button,
} from "@mui/material";
import { EmojiEvents, MonetizationOn } from "@mui/icons-material";
import { Info } from "lucide-react";

const moneyRainAnimation = `
@keyframes rain {
  0% { transform: translateY(0) rotate(0deg); opacity: 1; }
  100% { transform: translateY(500px) rotate(360deg); opacity: 0; }
}
`;

const moneySymbols = ["💸", "💰", "🍀"];

const RifasTrebolInfo = () => {
  const theme = useTheme();

  return (
    <Box position="relative" sx={{ overflow: "hidden", py: 4 }}>
      <style>{moneyRainAnimation}</style>

      {/* Dinero + Trébol lluvia */}
      {[...Array(25)].map((_, i) => (
        <Box
          key={i}
          sx={{
            position: "absolute",
            top: -20,
            zIndex: 2,
            left: `${Math.random() * 100}%`,
            fontSize: `${Math.random() * 14 + 14}px`,
            color: "#b5f7ff",
            animation: `rain ${Math.random() * 8 + 6}s linear infinite`,
            pointerEvents: "none",
          }}
        >
          {moneySymbols[Math.floor(Math.random() * moneySymbols.length)]}
        </Box>
      ))}

      {/* Tarjeta Informativa */}
      <Card
        sx={{
          maxWidth: 620,
          margin: "auto",
          px: 3,
          py: 4,
          borderRadius: 4,
          background: "transparent",
          backdropFilter: "blur(8px)",
          boxShadow: "0 8px 32px 0 rgba(0, 0, 0, 0.2)",
          position: "relative",
          zIndex: 1,
        }}
      >
        <CardContent>
          <Stack direction="row" alignItems="center" spacing={1} mb={2}>
            <EmojiEvents sx={{ color: "#007b55" }} />
            <Typography variant="h6" fontWeight="bold" color="#00573f">
              ¡Participa GRATIS y gana! 🎉
            </Typography>
          </Stack>

          <Typography variant="body1" fontSize="1.1rem" color="text.primary" mb={1}>
            Participa gratis y gánate <strong>$300</strong> o <strong>300 CLP</strong> 💵.
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Stack direction="row" spacing={1} alignItems="center" mb={1}>
            <MonetizationOn sx={{ color: "#008c5c" }} />
            <Typography fontWeight="bold" color="#00573f">
              ¿Cómo participar?
            </Typography>
          </Stack>
          <Typography variant="body2" mb={1}>
            1. Regístrate en la plataforma.<br />
            2. Sube un capture (foto) que demuestre que me sigues ✅<br />
            3. Etiqueta a tus amigos y comenta.
          </Typography>

          <Stack direction="row" spacing={1} alignItems="center" mt={2} mb={1}>
            <Info color="primary" />
            <Typography fontWeight="bold" color="primary">
              Detalles del sorteo
            </Typography>
          </Stack>
          <Typography variant="body2" mb={1}>
            🤑 Las tres primeras cifras<br />
            📍 Por la de Medellín<br />
            🗓 Este viernes <strong>30 de mayo</strong><br />
            🥇 ¡Tendrás dos oportunidades de ganar!
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default RifasTrebolInfo;
